module.exports = __webpack_public_path__ + "img/icon-start-ups-blue.2bc3ccc1.svg";